import { render, staticRenderFns } from "./PFLoanDocuments.vue?vue&type=template&id=3ad18f2e"
import script from "./PFLoanDocuments.vue?vue&type=script&lang=js"
export * from "./PFLoanDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports